import { useState, useEffect } from 'react';

// Create a global cache for loaded modules
const loadedModules: { [url: string]: any } = {};

// load an external module dynamically and cache it
const useDynamicModule = (url: string) => {
  const [module, setModule] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadModule = async () => {
      try {
        if (url) {
          // Check if the module is already loaded
          if (loadedModules[url]) {
            if (isMounted) {
              setModule(loadedModules[url]);
            }
          } else {
            // Load the module and add it to the cache
            const importedModule = await import(/* webpackIgnore: true */ url);
            if (isMounted) {
              setModule(importedModule);
              loadedModules[url] = importedModule;
            }
          }
        }
      } catch (error) {
        console.error('Error loading external module:', error);
      }
    };

    loadModule();

    return () => {
      isMounted = false;
    };
  }, [url]);

  return module;
};

export default useDynamicModule;
